/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Component,ElementRef,HostListener,OnInit,ViewChild } from '@angular/core';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import { Router,NavigationStart, RouterEvent} from '@angular/router';
import { Path } from  "../_common/constant/page-const";
import { Language } from '../../refresh/service/constant';
import { InitLoader } from './init-loader';
import { InputData } from '../_common/data/input-data';
import { LightBox } from 'src/refresh/layout/light-box/light-box.component';
import { TimerService } from 'src/refresh/service/timer-service';
import { filter } from 'rxjs/operators';
import { ProgressService } from 'src/refresh/service/progress-service';
import { ProgressSet } from './progress-set';
import { GAManager } from './ga-manager';
import { Util } from 'src/refresh/service/Util';
import { environment } from '../../environments/environment';
import { ItemList } from '../_common/constant/item-list';
import { ControlBaseComponent } from 'src/refresh/form-control/control-base.component';
import { CommonService } from 'src/refresh/service/common-service';

declare var option;

var show = console.log.bind( console );

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  providers:[InitLoader]
})
export class AppComponent implements OnInit  {

      public isReady:boolean = false;
      public isLoading:boolean = false;

      private progressSet:ProgressSet = new ProgressSet();
      private gAManager:GAManager = new GAManager();

      
      @HostListener('window:beforeunload', ['$event'])
          beforeunloadHandler(event) {
            return this.data.isSubmit;
          }  
      

      constructor(private translate: TranslateService,
                  private router: Router ,
                  private initLoader:InitLoader,
                  public  timerService:TimerService,
                  private commonService: CommonService,
                  private progress:ProgressService,
                  private elRef:ElementRef, 
                  private data:InputData,
                  private items:ItemList )  {  


            data.init();
            
            ////data.subject.siteKey = environment.site_key;
            this.translate.addLangs([Language.ENGLISH, Language.FRENCH]);
            
            let startLang:string = Language.ENGLISH;

            if ( option.french ) startLang = Language.FRENCH;

            this.translate.setDefaultLang(startLang);

            this.translate.use(startLang);

            setTimeout( () =>  { if ( this.isReady == false ) this.isLoading = true; } ,1500 );

            this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
                 this.data.init();
                 this.isReady = true;
                 this.isLoading = false;
                 this.progressSet.init(event,this.progress);
                 this.initLoader.load(event,this.gAManager);
                 this.setWindowTitle(event);

                 if ( this.gAManager.isReady == false ) {
                      this.gAManager.setTitle(event);
                 }

                 this.commonService.closeAllFAQ();

                 ControlBaseComponent.errorClassByLang = "input-error-"+ event.lang + " ";
            });

            this.progressSet.setIndexValue(this.progress);

            this.router.events.pipe( filter((event: RouterEvent) => event instanceof NavigationStart) )
                              .subscribe((event: NavigationStart) => {
                                          this.progressSet.set(event.url,this.progress);
                                          this.progress.isOpened = false;
                                          this.commonService.closeFAQ();
                                          this.commonService.closeBCImage();
                                          this.gAManager.send(event.url);
                                          let pageName = this.items.titleList.get(event.url);
                                          if ( !pageName ) {
                                                pageName = "";  // put the start page or default page name here.
                                          }
                                          if(pageName){
                                                document.title =  "NRS - " + pageName;
                                          } else {
                                                document.title =  "NRS";
                                          }
                              });


           let img1 = new Image(); img1.src = "refresh/assets/images/SLB_br_en2.png";
           let img2 = new Image(); img2.src = "refresh/assets/images/SLB_br_fr2.png";

           window.onpopstate = function () {}

           window.addEventListener("popstate",function(event) {

            if ( !event.state ) return;
                  if( typeof event.state == "object" && 
                      event.state.obsolete !== true) {

                      history.replaceState({"obsolete":true},"");
                      history.pushState(event.state,"");
                  }
                  else
                  if( typeof event.state == "object"  && event.state.obsolete === true) {
                           history.back();
                  }
                  
           },false);                    
      }  

   private setWindowTitle(event: LangChangeEvent) {
            
           let trans = event.translations;
           this.items.titleList.set("/"+Path.Start, trans.start.page_title );
           this.items.titleList.set("/"+Path.BeforeYouBegin, trans.before_you_begin.page_title );
           this.items.titleList.set("/"+Path.Setup1, trans.setup_1.page_title );
           this.items.titleList.set("/"+Path.Setup2, trans.setup_2.page_title );
           this.items.titleList.set("/"+Path.Setup3, trans.setup_3.page_title );
           this.items.titleList.set("/"+Path.Setup4, trans.setup_4.page_title );
           this.items.titleList.set("/"+Path.Setup5, trans.setup_5.page_title );
           this.items.titleList.set("/"+Path.AboutTheChildMain, trans.about_the_child_main.page_title );
           this.items.titleList.set("/"+Path.AboutTheChildScreen2, trans.about_the_child_screen_2.page_title_top );
           this.items.titleList.set("/"+Path.AboutTheParentsMain, trans.aboutParent.page_title_top );
           this.items.titleList.set("/"+Path.AboutTheParentsScreen1, trans.aboutParent.page_title );
           this.items.titleList.set("/"+Path.AboutTheParentsScreen2, trans.aboutParent.page_title );
           this.items.titleList.set("/"+Path.AboutTheParentsScreen3, trans.aboutParent.page_title );
           this.items.titleList.set("/"+Path.AboutTheParentsScreen4, trans.aboutParent.page_title );
           this.items.titleList.set("/"+Path.ContactInfoAndMailingAddress, trans.contact_info_and_mailing_address.page_title );
           this.items.titleList.set("/"+Path.FinalReview, trans.final_review.page_title );
           this.items.titleList.set("/"+Path.Transition1, trans.transition_1.page_title );
           this.items.titleList.set("/"+Path.BirthCertificate, trans.birth_certificate.page_title );
           this.items.titleList.set("/"+Path.BirthCertificateAreYouSure, trans.birth_certificate_are_you_sure.page_title );
           this.items.titleList.set("/"+Path.Transition2, trans.transition_2.page_title );
           this.items.titleList.set("/"+Path.CCBMain, trans.CCB_main.page_title );
           this.items.titleList.set("/"+Path.CCBAreYouSure, trans.CCB_are_you_sure.page_title );
           this.items.titleList.set("/"+Path.SINMain, trans.SIN_main.page_title );
           this.items.titleList.set("/"+Path.SINAreYouSure, trans.SIN_are_you_sure.page_title );
           this.items.titleList.set("/"+Path.ESRMain, trans.ESR_main.page_title );
           this.items.titleList.set("/"+Path.ESRAreYouSure, trans.ESR_are_you_sure.page_title );
           this.items.titleList.set("/"+Path.OrderSummary, trans.order_summary.page_title );
           this.items.titleList.set("/"+Path.NextRegistration, trans.next_registration.page_title );
           this.items.titleList.set("/"+Path.ProvincialPayment, trans.provincial_payment.page_title );
   }

   @ViewChild(LightBox) box: LightBox;
   public ngOnInit() {

      this.timerService.set( 600,(idx:number) => {  // 10 minutes
           if ( idx == 2  ) { 
                LightBox.closeBox();
                this.box.open();
           }
           else this.onExit();
      });      
   }
  
   public onContinue() {
            this.box.close();
            this.timerService.reset();
   }

   public  onExit()  {
        this.box.close();
        this.timerService.pause();
        this.data.init();
        this.progress.init(1);
        this.router.navigate([Path.Start]);  
   }


   public scrollTo(className:string, event) {
      event.preventDefault();
      this.elRef.nativeElement.querySelector('.'+className).setAttribute('tabindex', '-1');
      let  content  = this.elRef.nativeElement.querySelector('.'+className);
      if ( content ) { 
           content.scrollIntoView({behavior: "smooth"});
           content.focus();
      }
   }
}

